<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <el-input @keyup.enter.native="handleFilter" size="mini" style="width: 200px;" class="filter-item" :placeholder="'名称'" v-model="listQuery.key"> </el-input>
        <el-button class="filter-item" size="mini" v-waves icon="el-icon-search" @click="handleFilter">搜索</el-button>
        <permission-btn size="mini" v-on:btn-event="onBtnClicked"></permission-btn>
      </div>
    </sticky>
    <div class="app-container flex-item">
      <div class="bg-white" style="height: 100%;">
        <auth-table
          style="height:calc(100% - 60px)"
          ref="mainTable"
          :select-type="'checkbox'"
          :table-fields="headerList"
          :data="list"
          :v-loading="listLoading"
          @row-click="rowClick"
          @selection-change="handleSelectionChange"
        ></auth-table>
        <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="handleCurrentChange" />
      </div>
      <el-dialog v-el-drag-dialog class="dialog-mini" width="500px" :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
        <auth-form ref="dataForm" :rules="rules" :edit-model="true" :form-fields="headerList" v-model="temp" :col-num="1"></auth-form>
        <div slot="footer">
          <el-button size="mini" @click="dialogFormVisible = false">取消</el-button>
          <el-button size="mini" v-if="dialogStatus == 'create'" type="primary" @click="createData">确认</el-button>
          <el-button size="mini" v-else type="primary" @click="updateData">确认</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import * as agents from '@/api/agents'
import waves from '@/directive/waves' // 水波纹指令
import Sticky from '@/components/Sticky'
import permissionBtn from '@/components/PermissionBtn'
import Pagination from '@/components/Pagination'
import elDragDialog from '@/directive/el-dragDialog'
import { defaultVal } from '@/utils/index'
import extend from '@/extensions/common.js'
import AuthForm from '../../components/Base/AuthForm.vue'
import AuthTable from '../../components/Base/AuthTable.vue'
import ColumnDefine from '@/interface/columnDefine'
export default {
  name: 'agent',
  components: { Sticky, permissionBtn, Pagination, AuthTable, AuthForm, },
  directives: {
    waves,
    elDragDialog,
  },
  computed: {
    ...mapGetters(['agentId']),
  },
  mixins: [extend],
  data() {
    return {
      headerList: [], // 主列表列定义
      multipleSelection: [], // 列表checkbox选中的值
      tableKey: 0,
      agentList:[],
      agentOptions:[],
      allAgentOptions:[],
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        // 查询条件
        page: 1,
        limit: 20,
        key: undefined,
      },
      temp: { },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '添加',
      },
      rules: {
        name: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
        account: [{ required: true, message: '账号不能为空', trigger: 'blur' }],
      },
    }
  },
  created() {
    this.getList();
    if(this.agentId != -1){
      this.rules['parentAccount'] = [{ required: true, message: '上级代理不能为空', trigger: 'blur' }];
    }
  },
  methods: {

    rowClick(row) {
      this.$refs.mainTable.clearSelection()
      this.$refs.mainTable.toggleRowSelection(row)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    onBtnClicked: function(domId,callback) {
      console.log('you click:' + domId)
      switch (domId) {
        case 'btnAdd':
          this.handleCreate()
          break
        case 'btnEdit':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '只能选中一个进行编辑',
              type: 'error',
            })
            return
          }
          if(this.agentId == this.multipleSelection[0].id){
            this.$message({
              message: '不能编辑此代理商',
              type: 'error',
            })
            return
          }

          this.handleUpdate(this.multipleSelection[0])
          break
        case 'btnDel':
          if (this.multipleSelection.length < 1) {
            this.$message({
              message: '至少删除一个',
              type: 'error',
            })
            return
          }
          this.handleDelete(this.multipleSelection)
          break
          case 'btnExport':
            this.$refs.mainTable.exportExcel('资源文件',callback)
            break
        default:
          break
      }
    },
    getList() {
      this.listLoading = true
      this.getAgents();
      agents.getList(this.listQuery).then((response) => {
        this.list = response.data.sort((a,b)=>a.level - b.level)
        this.total = response.count
        this.listLoading = false
      })
    },
    getAgents(){
      agents.getList({page:1,limit:100000}).then(res=>{
        this.agentList = res.data;
        this.allAgentOptions =[...this.agentList.map(item=>{return {value:item.account,label:item.name,cascadeId:item.cascadeId}})];
        if(!this.temp.cascadeId){
          this.agentOptions =[...this.allAgentOptions];
        } else {
          this.agentOptions =[...this.allAgentOptions.filter(item=>item.cascadeId.indexOf(this.temp.cascadeId) < 0)];
        }

        this.headerList = [
          new ColumnDefine('id', 'Id', false, false, '', '', 'bigint', 'bigint', 'Id'),
          new ColumnDefine('name', '名称', true, true, 'text', '', 'string', 'varchar', 'Name'),
          new ColumnDefine('account', '账号', true, true, 'text', '', 'string', 'varchar', 'Account'),
          new ColumnDefine('parentAccount', '上级代理', true, true, 'select', [...this.agentOptions], 'string', 'varchar', 'ParentAccount'),
          new ColumnDefine('level', '等级', false, true, 'number', '', 'int', 'int', 'Level'),
          new ColumnDefine('enableIMEICheck', '启用IMEI检查', true, true, 'switch', '', 'bool', 'bit', 'EnableIMEICheck')
        ];
      });
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val.page
      this.listQuery.limit = val.limit
      this.getList()
    },
    handleModifyStatus(row, disable) {
      // 模拟修改状态
      this.$message({
        message: '操作成功',
        type: 'success',
      })
      row.disable = disable
    },
    resetTemp() {
      let obj = {};
      this.headerList.forEach((item) => {
        obj[item.columnName] = defaultVal(item.entityType)
      })
      this.temp =Object.assign({}, obj) // copy obj
    },
    handleCreate() {
      // 弹出添加框
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    createData() {
      // 保存提交
      this.$refs['dataForm'].validate(() => {
        if(!this.temp.parentAccount){
          this.temp.level = 1;
        } else {
          this.temp.level = this.agentList.find(item=>item.account == this.temp.parentAccount).level+1;
        }

        this.temp.account = this.temp.account.toUpperCase();

        agents.add(this.temp).then(() => {
          this.getList();
          this.dialogFormVisible = false
          this.$notify({
            title: '成功',
            message: '创建成功',
            type: 'success',
            duration: 2000,
          })
        })
      })
    },
    handleUpdate(row) {

      // 弹出编辑框
      this.temp = Object.assign({}, row) // copy obj

      this.getAgents();
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    updateData() {
      // 更新提交
      this.$refs['dataForm'].validate(() => {
        if(!this.temp.parentAccount){
          this.temp.level = 1;
        } else {
          this.temp.level = this.agentList.find(item=>item.account == this.temp.parentAccount).level+1;
        }
        this.temp.account = this.temp.account.toUpperCase();
        const tempData = Object.assign({}, this.temp)
        agents.update(tempData).then(() => {
          // for (const v of this.list) {
          //   if (v.id === this.temp.id) {
          //     const index = this.list.indexOf(v)
          //     this.list.splice(index, 1, this.temp)
          //     break
          //   }
          // }
          this.getList();

          this.dialogFormVisible = false
          this.agentOptions = [...this.allAgentOptions];

          this.$notify({
            title: '成功',
            message: '更新成功',
            type: 'success',
            duration: 2000,
          })
        })
      })
    },
    handleDelete(rows) {
      // 多行删除
      this.delrows(agents, rows)
    },
  },
}
</script>
<style>
.dialog-mini .el-select {
  width: 100%;
}
</style>
